export const en = {
    "error-not-loaded": "You haven't uploaded anything yet",
    "image-table-copy": "Copy",
    "image-table-delete": "Delete",
    "image-table-error": "An error has occurred",
    "image-table-error-big-size": "File size exceeded",
    "image-table-error-incorrect-image": "Incorrect image",
    "image-table-error-limit": "The quota for images has been exceeded",
    "image-table-error-low-size": "The file size is less than the allowed one",
    "image-table-error-wrong-size": "Invalid file size",
    "info-sounds": "Sounds longer than 2 minutes will be cut to the maximum length.",
    "info-to-upload": "To upload files, move them to the area or click on it.",
    "menu-images": "Images",
    "menu-sounds": "Sounds",
    "limit-size": "{used} of {total}",
    "add-file": "Upload file",
    "delete-error": "Failed to delete files",
    "sounds-quota-is-exceed": "Sound quota exceeded",
    "sounds-process-error": "An error occurred while processing the sound file",
    "sounds-in-process": "Sound track is being processed"
} as const;
export const ru = {
    "error-not-loaded": "Вы еще ничего не загрузили",
    "image-table-copy": "Скопировать",
    "image-table-delete": "Удалить",
    "image-table-error": "Произошла ошибка",
    "image-table-error-big-size": "Превышен размер файла",
    "image-table-error-incorrect-image": "Некорректное изображение",
    "image-table-error-limit": "Превышена квота на изображения",
    "image-table-error-low-size": "Размер файла меньше допустимого",
    "image-table-error-wrong-size": "Недопустимый размер файла",
    "info-sounds": "Звуки длиной более 2 минут будут обрезаны до максимальной длины.",
    "info-to-upload": "Для загрузки файлов переместите их в область или нажмите на нее.",
    "menu-images": "Изображения",
    "menu-sounds": "Звуки",
    "limit-size": "{used} из {total}",
    "add-file": "Добавить файл",
    "delete-error": "Не удалось удалить файлы",
    "sounds-quota-is-exceed": "Превышена квота на звуки",
    "sounds-process-error": "Произошла ошибка при обработке звукового файла",
    "sounds-in-process": "Звуковая дорожка в обработке"
} as const;